<template>
  <div class="seekers-main">
    <div class="admin-header">
      <div class="admin-header-left">
        <div class="text-header">
          <span class="text-header__top">Import from Job Boards</span>
          <span class="text-header__bottom">Job Seekers</span>
        </div>
        <div class="form-block__content">
          <div class="vtfilter-input-wrap" :class="{ opened: show_filter === 'vacancies' }">
            <input
              v-model="selected_vacancies_names"
              class="vtfilter-input"
              type="text"
              placeholder="All vacancies"
              readonly
              @click.stop="set_show_filter('vacancies')"
            />
            <img src="/static/icons/drop_arrow.svg" />
          </div>
          <vtfilter
            v-if="show_filter === 'vacancies'"
            class="th_filter"
            :type="'list'"
            :list="vacancies"
            :selected_list="selected_vacancy"
            input_placeholder="Type vacancy here"
            :filter_name="'vacancies'"
            @input="set_selected_vacancy"
            @apply="apply_filter('vacancies')"
            @cancel="cancel_filter"
            @clear="clear_filter('vacancies')"
          />
        </div>
        <div class="form-block__content">
          <div class="vtfilter-input-wrap" :class="{ opened: show_filter === 'statuses' }">
            <input
              v-model="selected_statuses_names"
              class="vtfilter-input"
              type="text"
              placeholder="Status"
              readonly
              @click.stop="set_show_filter('statuses')"
            />
            <img src="/static/icons/drop_arrow.svg" />
          </div>
          <vtfilter
            v-if="show_filter === 'statuses'"
            class="th_filter"
            :type="'list'"
            :list="statuses"
            :selected_list="selected_status"
            :search="false"
            :filter_name="'statuses'"
            @input="set_selected_status"
            @apply="apply_filter('statuses')"
            @cancel="cancel_filter"
            @clear="clear_filter('statuses')"
          />
        </div>
      </div>
      <div class="admin-header-right">
        <vbutton
          label="admin.company.board.seeker_table.delete"
          color="transparent"
          :disabled="!selected_list || !selected_list.length || loading"
          text_color="grey"
          @click="hide"
        />
        <vbutton
          class="seekers-invite-btn"
          :label="'admin.company.board.seeker_table.invite'"
          :disabled="!selected_list || !selected_list.length || loading"
          @click="invite"
        />
      </div>
    </div>
    <vtable class="seekers-table">
      <thead>
        <th class="seekers-table-id">
          <div class="checkbox-wrapper">
            <div class="checkbox-content">
              <vcheckbox v-model="all_selected" />
            </div>
            <div class="checkbox-desc">ID</div>
          </div>
        </th>
        <th class="seekers-table-date">Date of creation</th>
        <th class="seekers-table-info">Candidate / e-mail / phone number</th>
        <th class="seekers-table-vacancy">Vacancy</th>
        <th class="seekers-table-cv">CV</th>
        <th class="seekers-table-status">Status</th>
      </thead>
      <tbody>
        <tr v-for="seeker in selected_seekers" :key="seeker.id">
          <td>
            <div class="checkbox-wrapper">
              <div class="checkbox-content">
                <vchecklabel v-model="seeker.is_selected" />
              </div>
              <div class="checkbox-desc">{{ seeker.id }}</div>
            </div>
          </td>
          <td>{{ get_date(seeker.created_at) }}</td>
          <td>
            {{ seeker.first_name + ' ' + seeker.last_name }} / {{ seeker.email || '*****' }} /
            {{ seeker.phone || '*****' }}
          </td>
          <td>{{ get_vacancy(seeker.vacancy_id) }}</td>
          <td><a class="green-link" :href="seeker.download_resume_url">CV</a></td>
          <td>
            {{ get_status(seeker) }}
            <span v-if="!seeker.invited && !seeker.unwanted" class="bold-status">Found</span>
          </td>
        </tr>
      </tbody>
    </vtable>

    <div
      v-if="selected_seekers && selected_seekers.length && page_count > 1"
      class="seekers-pagination-wrapper"
    >
      <vuetify-pagination
        v-if="selected_seekers && selected_seekers.length && page_count > 1"
        :page="page"
        :length="page_count"
        :total-visible="6"
        @input="input_page"
      ></vuetify-pagination>
    </div>
  </div>
</template>

<script>
  import VueScrollTo from 'vue-scrollto';
  import moment from 'moment';
  import axios from 'axios';
  import { STORE_PREFIX } from '../../constants.js';
  import { mapGetters } from 'vuex';

  export default {
    name: 'AdminImportSeekers',

    props: ['companyId'],

    data() {
      return {
        seekers: [],
        selected_seekers: [],
        selected_vacancy: [],
        selected_status: [1],
        show_filter: 'none',
        page_count: 1,
        page: 1,
        loading: false,
        statuses: [
          {
            id: 1,
            name: 'Found'
          },
          {
            id: 2,
            name: 'Invited'
          },
          {
            id: 3,
            name: 'Unwanted'
          }
        ],

        isSelectedAllFilters: {}
      };
    },

    computed: {
      ...mapGetters(STORE_PREFIX + 'admin', {
            vacancies: 'vacancies/list'
        }),
      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },

      dateFormat() {
        return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
      },

      all_selected: {
        get() {
          if (!this.selected_seekers || !this.selected_seekers.length) {
            return false;
          }
          return this.selected_seekers.every(seeker => seeker.is_selected);
        },

        set(value) {
          this.selected_seekers.forEach(seeker => (seeker.is_selected = value));
        }
      },

      selected_list() {
        if (!this.selected_seekers || !this.selected_seekers.length) {
          return [];
        }

        return this.selected_seekers.filter(seeker => seeker.is_selected);
      },

      selected_statuses_names() {
        if (!this.selected_status || !this.selected_status.length) {
          return '';
        }

        let row = '';

        this.selected_status.forEach((item, index) => {
          const status = this.statuses.find(loc => loc.id === item);
          if (index !== 0) {
            row += `, ${status.name}`;
          } else {
            row += `${status.name}`;
          }
        });

        return row;
      },

      selected_vacancies_names() {
        if (!this.selected_vacancy || !this.selected_vacancy.length) {
          return '';
        }

        let row = '';

        this.selected_vacancy.forEach((item, index) => {
          const vacancy = this.vacancies.find(loc => loc.id === item);
          if (index !== 0) {
            row += `, ${vacancy.name}`;
          } else {
            row += `${vacancy.name}`;
          }
        });

        return row;
      }
    },

    watch: {
      seekers: {
        immediate: true,
        handler(val) {
          const selected = this.seekers.map(seeker => {
            return Object.assign({}, seeker, {
              is_selected: false
            });
          });
          this.selected_seekers.splice(0, this.selected_seekers.length, ...selected);
        }
      },

      selected_status(val) {
        this.page = 1;
      }
    },

    created() {
      this.fetch_seekers();
    },

    methods: {
      fetch_seekers() {
        let params_string = '';
        this.selected_vacancy.forEach((item, index) => {
          if (index === 0) {
            params_string += `filter[vacancy_id][]=${item}`;
          } else {
            params_string += `&filter[vacancy_id][]=${item}`;
          }
        });

        let status = '';
        let invited = false;
        let unwanted = false;
        this.selected_status.forEach((item, index) => {
          if (index === 0) {
            status = `filter[status_id][]=${item}`;
          } else {
            status = status + `&filter[status_id][]=${item}`;
          }
        });

        axios
          .get(
            `/v2/boards/seekers?${params_string}&${status}&filter[company_id]=${this.companyId}`,
            {
              params: {
                page: this.page
              }
            }
          )
          .then(response => {
            const data = response.data;
            if (data && data._embedded && data._embedded.seekers) {
              this.seekers = data._embedded.seekers;
              this.page_count = data._page_count;
              this.page = data._page;
            }
            VueScrollTo.scrollTo('body', 500);
          });
      },

      input_page(page) {
        this.page = page;
        this.fetch_seekers();
      },

      clear_filter(filter) {
        switch (filter) {
          case 'statuses':
            this.set_selected_status([]);
            break;
          case 'vacancies':
            this.set_selected_vacancy([]);
            break;
          default:
            break;
        }
        this.cancel_filter();
        this.fetch_seekers();
      },

      set_selected_status(model) {
        this.selected_status = model.result;
        if (model.params && model.params.name) {
          this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
        }
      },

      set_selected_vacancy(model) {
        this.selected_vacancy = model.result;
        if (model.params && model.params.name) {
          this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
        }
      },

      apply_filter(filter) {
        if (this.isSelectedAllFilters[filter]) {
          this.clear_filter(filter);
          return;
        }
        this.cancel_filter();
        this.fetch_seekers();
      },

      cancel_filter() {
        this.set_show_filter('none');
      },

      set_show_filter(v) {
        this.show_filter = v;
      },

      get_status(seeker) {
        let status = '';

        if (seeker.status_id === 2) {
          status = 'Invited';
        }

        if (seeker.status_id === 3) {
          status = status ? `${status}, Unwanted` : 'Unwanted';
        }

        if (!seeker.invited && !seeker.unwanted) {
          status = '';
        }

        return status;
      },

      get_date(date) {
        return moment.unix(date).format(`${this.dateFormat} HH:mm`) || '';
      },

      get_vacancy(vacancy_id) {
        if (!this.vacancies || !this.vacancies.length) {
          return '';
        }
        const vacancy = this.vacancies.find(vacancy => +vacancy.id === vacancy_id);
        return vacancy ? vacancy.name : '';
      },

      hide() {
        let selected_seekers_ids = this.selected_seekers
          .filter(seeker => seeker.is_selected)
          .map(seeker => {
            return Object.assign({}, seeker, {
              unwanted: true,
              status_id: 3
            });
          });
        this.loading = true;
        axios
          .put('/v2/boards/seekers', selected_seekers_ids)
          .then(() => {
            this.$noty.success('Candidates successfully removed');
            setTimeout(() => {
              this.fetch_seekers();
              this.loading = false;
            }, 300);
          })
          .catch(() => {
            this.$noty.success(this.$tr('common.error'));
            this.loading = false;
          });
      },

      invite() {
        let selected_seekers_ids = [];
        const seekers_array = this.selected_seekers.filter(seeker => !seeker.invited);
        seekers_array.forEach(seeker => {
          if (seeker.is_selected) {
            selected_seekers_ids.push(seeker.id);
          }
        });
        if (!selected_seekers_ids || !selected_seekers_ids.length) {
          this.$noty.success('Candidates successfully invited');
          return;
        }
        this.loading = true;
        axios
          .post('/v2/boards/invites', {
            seekers: selected_seekers_ids
          })
          .then(() => {
            this.fetch_seekers();
            this.$noty.success('Candidates successfully invited');
            this.fetch_seekers();
            this.loading = false;
          })
          .catch(() => {
            this.$noty.success(this.$tr('common.error'));
            this.loading = false;
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.seekers-table {
  th,
  td {
    box-sizing: border-box;
    white-space: normal;
  }

  .seekers-table-checkbox {
    width: 10px;
  }

  .seekers-table-id {
    width: 80px;
  }

  .seekers-table-info {
    width: 300px;
  }

  .seekers-table-vacancy {
    width: 180px;
  }

  .seekers-table-cv {
    width: 100px;
  }

  .seekers-table-status {
    width: 200px;
  }

  .seekers-table-date {
    width: 150px;
  }

  th {
    // font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.005em;
    color: #607183;
    border-bottom: 1px solid #d2d6e0;
    box-sizing: border-box;
    white-space: normal;
    padding: 18px 10px 20px 20px;
    cursor: default;
  }

  td {
    // font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.005em;
    color: #233346;
    height: 80px;
    vertical-align: middle;
    box-sizing: border-box;
    padding: 18px 10px 20px 20px;
  }

  tbody {
    tr {
      border-bottom: 1px solid #d2d6e0;
    }
  }
}

.form-block__content {
  position: relative;
}

.text-header {
  padding: 5px 0 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 41px;
  letter-spacing: 0.005em;
  color: #233346;
}

.text-header {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 32px;
  padding: 0;

  .text-header__top {
    // font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 19px;
    letter-spacing: 0.005em;
    color: #233346;
  }
  .text-header__bottom {
    // font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 32px;
    letter-spacing: 0.005em;
    color: #233346;
  }
}

.admin-header {
  margin-top: 0;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 0;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
}

.admin-header-left {
  display: flex;
  align-items: flex-start;

  .form-block__content {
    margin-right: 10px;
    width: 157px;
  }
}

.admin-header-right {
  display: flex;
  align-items: center;
}
.seekers-pagination-wrapper {
  display: flex;
  align-items: center;
  margin-top: 50px;
}

.seekers-invite-btn {
  width: 124px;
  margin-left: 32px;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
}

.checkbox-content {
  margin-right: 17px;
  width: 18px;
  display: flex;
  align-items: center;
}

.green-link {
  // font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.005em;
  color: $green;

  &:hover {
    color: $green-hover;
  }

  &:focus,
  &:active {
    color: $green-active;
  }
}

.bold-status {
  // font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.005em;
  color: #233346;
}
</style>

<style lang="scss">
@import '@/styles/variables.scss';

.seekers-main {
  padding-bottom: 50px;

  .vtfilter-input-wrap {
    position: relative;

    img {
      position: absolute;
      top: 17px;
      right: 21px;
      transform: rotate(180deg);
      cursor: pointer;
    }

    &.opened {
      img {
        transform: rotate(0deg);
      }
    }
  }

  .vtfilter-input {
    width: 100%;
    padding-right: 22px;
    padding-left: 20px;
    cursor: pointer;

    &[readonly] {
      color: #232323;

      &::placeholder {
        color: #232323;
      }
    }
  }

  .th_filter {
    position: absolute;
    left: 0;
    top: 45px;
    &.right {
      right: 0;
      left: auto;
    }

    &.th_filter_bottom {
      left: -315px;
      top: auto;
      bottom: 0;
    }
  }
}
</style>
